/*
 * Author: Roger
 * File Created: Wednesday, 24-08-14 03:17 pm
 * Last Modified: Saturday, 24-09-14 09:36 am, by Roger
 */

import type { IconName } from './_components/icons';

interface SiteMapItem {
  i18nKey: string;
  url?: string;
}

export const siteMap: SiteMapItem[] = [
  {
    i18nKey: 'promotions',
    url: '',
  },
  {
    i18nKey: 'events',
    url: '',
  },
  {
    i18nKey: 'blog',
    url: '',
  },
  // {
  //   i18nKey: 'media',
  //   url: '',
  // },
  {
    i18nKey: 'faq',
    url: '',
  },
  // {
  //   i18nKey: 'about-us',
  //   url: '',
  // },
];

interface socialIconItem {
  iconName: IconName;
  url?: string;
  size: {
    xs: string;
    md: string;
  };
}

export const socialIcons: socialIconItem[] = [
  {
    iconName: 'Telegram',
    url: 'https://t.me/TheDeHelpBot',
    size: {
      xs: '36px',
      md: '72px',
    },
  },
  {
    iconName: 'LinkedIn',
    url: 'https://www.linkedin.com/company/thedecard',
    size: {
      xs: '36px',
      md: '72px',
    },
  },
  // {
  //   iconName: 'Facebook',
  //   url: 'https://www.facebook.com/',
  //   size: {
  //     xs: '36px',
  //     md: '72px',
  //   },
  // },
  {
    iconName: 'Twitter',
    url: 'https://x.com/TheDeCard',
    size: {
      xs: '36px',
      md: '72px',
    },
  },
  // {
  //   iconName: 'YouTube',
  //   url: 'https://www.youtube.com/',
  //   size: {
  //     xs: '36px',
  //     md: '72px',
  //   },
  // },
];
